// extracted by mini-css-extract-plugin
module.exports = {"codiEspectador":"codiespectador_codiEspectador__1PBhX","subtitols":"codiespectador_subtitols___Zhs_"};